// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o1yY","right":"styles_right__2Sp83"};